import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m1.817 4.524 9.1-3.568a2.94 2.94 0 0 1 2.162 0l9.1 3.568a1.76 1.76 0 0 1 1.071 1.662v11.628a1.76 1.76 0 0 1-1.067 1.662l-9.1 3.569a2.96 2.96 0 0 1-2.162 0l-9.1-3.569A1.76 1.76 0 0 1 .75 17.814V6.186a1.76 1.76 0 0 1 1.067-1.662M12 9.353 1.104 5.081M12 9.353l10.896-4.272M12 23.25V9.353"
    }, null, -1)
  ]));
}
const programmingModule = { render };
export {
  programmingModule as default,
  render
};
//# sourceMappingURL=programming-module.svg.js.map
